import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Helmet } from 'react-helmet';

// SALES COMPONENTS
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import SalesHeader from "./components/Sales/Common/Header/header";
import SalesRoutes from "./routes/SalesRoutes/SalesRoutes";

class SalesApp extends Component {


  componentDidMount() {
    document.title = "Insomnia Cookies - Sales";
  }

  render() {
    return (
      <GoogleReCaptchaProvider
        useEnterprise
        reCaptchaKey={
          window.environment.REACT_APP_ENTERPRISE_RECAPTCHA_SITE_KEY
        }
        scriptProps={{
          async: true,
          defer: true
        }}
      >
        <Router>
          <div className="sales-app min-h-screen ">
            <Helmet>
              <title>Insomnia Cookies - Sales</title>
              <meta name="description" content="Custom orders and sales for Insomnia Cookies" />
            </Helmet>
            {/* Sales Header */}
            <SalesHeader />
            {/* Sales Main Content */}
            <main className="flex-1 bg-dark">
              <Switch>
                {/* Sales Routes */}
                <Route path="/sales" component={SalesRoutes} />
              </Switch>
            </main>
          </div>
        </Router>
      </GoogleReCaptchaProvider>
    );
  }
}

export default SalesApp;
